import styled, { css } from "styled-components";
import * as React from "react";

import Grid, { HedronBoxProps } from "src/library/components/Hedron";
import { breakpoint } from "src/library/utils/styled-media-queries/index";

const MainContent = styled(Grid.Box).attrs({ className: "main-content-inner" })`
  ${({ theme }) => css`
    position: relative;
    flex: 1 1 auto;
    margin-left: auto;
    margin-right: auto;
    width: 100%;

    &:only-child {
      margin-right: 0px;
      padding-bottom: 100px;
    }

    ${breakpoint("md", theme)} {
      overflow: visible;
      margin-top: 0;
      margin-right: ${({ theme }) => theme.spacing.margins.lg};
    }
  `}
`;

interface MainContentProps extends HedronBoxProps {
  Header?: React.ReactNode;
  className?: string;
}

const MainContentWrapper: React.ReactFCWithChildren<MainContentProps> = ({
  children, Header, className, ...hedronProps
}) => {
  return (
    <MainContent
      {...hedronProps}
      className={`main-content ${className ? className : ""}`}
    >
      {!!Header && Header}

      <div className="inner-content">
        {children}
      </div>
    </MainContent>
  );
};

export default MainContentWrapper;
